import { supabase } from "../supabaseClient";

export const LS_NAME_KEY   = "orbit_display_name";
export const LS_SCREEN_KEY = "orbit_last_screen";
export const LS_VIEW_KEY   = "orbit_last_view";

// Name is stored per-user so two accounts on the same device never bleed into each other.
function _nameKey(userId) { return userId ? `orbit_display_name_${userId}` : LS_NAME_KEY; }

export function _getStoredName(userId) {
  try {
    // Check user-scoped key first; fall back to legacy unscoped key then clear it.
    const scoped = userId ? localStorage.getItem(_nameKey(userId)) : null;
    if (scoped) return scoped;
    const legacy = localStorage.getItem(LS_NAME_KEY);
    if (legacy && userId) {
      // Migrate: move legacy value into scoped key and remove the shared one.
      localStorage.setItem(_nameKey(userId), legacy);
      localStorage.removeItem(LS_NAME_KEY);
      return legacy;
    }
    return legacy || "";
  } catch { return ""; }
}
export function _setStoredName(name, userId) {
  try {
    const key = _nameKey(userId);
    if (name) localStorage.setItem(key, name); else localStorage.removeItem(key);
    // Always clean up the legacy unscoped key.
    localStorage.removeItem(LS_NAME_KEY);
  } catch {}
}

/**
 * Returns the display name to show for the logged-in user.
 * Precedence: localStorage → Supabase full_name (if explicitly set) → email prefix → "there"
 */
export function getDisplayName(user, fallback="there") {
  const userId = user?.id;
  const stored = _getStoredName(userId);
  if (stored && stored.toLowerCase() !== "morgan") return stored;
  if (user?.user_metadata?.name_explicitly_set && user?.user_metadata?.full_name && user.user_metadata.full_name.toLowerCase() !== "morgan")
    return user.user_metadata.full_name;
  const prefix = user?.email ? user.email.split("@")[0] : "";
  if (prefix && prefix.toLowerCase() !== "morgan") return prefix;
  return fallback;
}

/** Returns true when the user still needs to set their name (first-run prompt). */
export function needsNamePrompt(user) {
  const userId = user?.id;
  const stored = _getStoredName(userId);
  if (stored && stored.toLowerCase() !== "morgan") return false;
  if (user?.user_metadata?.name_explicitly_set && user?.user_metadata?.full_name && user.user_metadata.full_name.toLowerCase() !== "morgan") {
    _setStoredName(user.user_metadata.full_name, userId);
    return false;
  }
  return true;
}

/** Save the chosen name locally and fire-and-forget to Supabase. */
export async function saveDisplayName(name, userId) {
  _setStoredName(name, userId);
  try { await supabase.auth.updateUser({ data: { full_name: name, name_explicitly_set: true } }); } catch(_) {}
}
